<script setup>
import { useVideoCallState } from "@/stores/videoCallState";
import { EventManager, Events } from "@events";
import { onMounted, ref, computed } from "vue";
import ZoomableVideo from "./ZoomableVideo.vue";
import { SectionList } from "@module-system";
import ListContainer from "@module-system/ViewModule/ListContainer.vue";
import { PhotoPanelEvents } from "@/../modules/CoreModules/Photo/helpers/photoPanelActions";

let props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
  peer: {
    type: Object,
    required: true,
  },
  disableVideoMutedIcon: {
    type: Boolean,
    default: false,
  },
});

const eventEmitter = EventManager.getEventEmitter(props.rtcId);

const zoomDisabled = window.CONFIG.ZOOM_DISABLED;

const state = useVideoCallState(props.rtcId);

const isLocalBtnsEnabled = ref(false);

function onVideoRef(video) {
  console.log("peer video ref set");
  console.log(video);
  state.setPeerVideoElement(props.peer.peerName, video);

  eventEmitter.emit(Events.PeerVideoElementSet, {
    peer: props.peer,
    videoElement: video,
  });
}

const isAgent = computed(() => {
  return state.role === "agent";
});

function DrawRedFrame(data) {
  const canvas = document.getElementById("red-frame");
  if (canvas && canvas.getContext) {
    canvas.style.display = "inline";
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.lineWidth = "2";
    ctx.strokeStyle = "red";

    const widthMargin = 20;

    if (data.width > data.height) {
      const ratio = data.width / canvas.width;
      const newHeight = data.height / ratio;

      ctx.strokeRect(0, (canvas.height - newHeight) / 2, canvas.width, newHeight);
    } else {
      const ratio = data.height / canvas.height;
      const newWidth = data.width / ratio;

      ctx.strokeRect((canvas.width - newWidth) / 2 - widthMargin, 0, newWidth + widthMargin * 2, canvas.height);
    }
  }
}

onMounted(() => {
  let originalRedFrame = null;
  if (isAgent.value && props.peer.type === "local") {
    eventEmitter.on(Events.SignalingMessageReceived, async (msg) => {
      if (msg?.type != "red-frame-mobile-screen") {
        return;
      }

      console.log("Red Frame Mobile Screen", msg);
      originalRedFrame = msg;
      DrawRedFrame(msg);
    });

    eventEmitter.on(PhotoPanelEvents.PhotoPanelTakePhotoOn, () => {
      // draw 4:3 red frame if mobile screen
      if (originalRedFrame) {
        DrawRedFrame({ width: 1080, height: 1440 });
      }
    });

    eventEmitter.on(PhotoPanelEvents.PhotoPanelTakePhotoOff, () => {
      // redraw original red frame
      if (originalRedFrame) {
        DrawRedFrame(originalRedFrame);
      }
    });

    //DrawRedFrame({ width: 1080, height: 2273 });
    //DrawRedFrame({ width: 414, height: 896 });
  }

  if (props.peer.type === "local") {
    isLocalBtnsEnabled.value = true;
  }
});
</script>

<template>
  <div :class="'peer-video ' + props.peer.type">
    <ZoomableVideo
      :enableZoom="!zoomDisabled && props.peer.type == 'remote'"
      autoplay
      playsinline
      :muted="props.peer.type == 'local'"
      v-bind="$props"
      @onVideoRef="onVideoRef"></ZoomableVideo>
    <canvas id="red-frame"></canvas>
    <div v-if="isLocalBtnsEnabled" id="local-btns">
      <ListContainer :rtc-id="props.rtcId" :section-type="SectionList.LocalButtons"></ListContainer>
    </div>
  </div>
</template>

<style>
.peer-video {
  flex: 1;
  overflow: hidden;
}

.peer-video video {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

@media screen and (min-width: 800px) {
  /* make local video absolute and  right bottom corner when on PC */
  .peer-video.local {
    position: absolute;
    bottom: 0;
    right: 0;
    /*
    width: 200px;
    */
    height: 150px;
    max-width: 200px;
    z-index: 100;
  }
  .peer-video.local > video {
    border: 1px solid rgba(0, 100, 0, 0.4);
    border-radius: 3px;
  }
}

@media screen and (max-width: 799px) {
  .peer-video.remote,
  .peer-video.local {
    position: relative;
  }
}

.peer-video.local {
  transform: rotateY(180deg);
}

#red-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: none;
}

#local-btns {
  position: absolute;
  bottom: 5px;
  right: 5px;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

#local-btns .ecv-call-button {
  font-size: 0.8rem;
  width: 30px;
  height: 30px;
  margin-top: 5px;
}
</style>
